import React from "react";
import GmailConnect from "./GmailConnect";

export default function MPBossInvoices() {
  //userId={currentUser.id}
  return (
    <div>
      <GmailConnect />
    </div>
  );
}
